module.exports = __webpack_public_path__ + "img/18.249889fb.svg";